import { WARNING_TYPES_UPDATE } from '../mutationTypes';
import { alarmConfigGetAlarmTypeApi } from '../../api/warning';

const initState = {
  warningTypes: [],
};

const state = JSON.parse(JSON.stringify(initState));

const mutations = {
  [WARNING_TYPES_UPDATE](stateObj, newValue) {
    const states = stateObj;
    states.warningTypes = newValue;
  },
};

const actions = {
  // 报警类型更新
  async fetchWarningTypes({ commit }) {
    const resData = await alarmConfigGetAlarmTypeApi({});
    commit(WARNING_TYPES_UPDATE, resData.data || []);
  },
};

export default {
  name: 'warning',
  namespaced: true,
  state,
  mutations,
  actions,
};
